import React from 'react';

import { LogoSpinner } from 'ui/spinner';
import ErrorOverlay from 'ui/error-overlay';

import { useLoggedInUser } from './hooks';

import s from './styles.pcss';

export default function AuthProvider(props) {
  const loggedInUser = useLoggedInUser();

  // Show a loader while getting the auth user
  if (loggedInUser.isLoading === true) {
    return (
      <div className={s.container}>
        <LogoSpinner size={32} />
      </div>
    );
  }

  // Show an error if cannot verify the auth user
  if (loggedInUser.isSuccess !== true) {
    return <ErrorOverlay />;
  }

  return props.children;
}
